export const emptyResourceRedirect = ({ path, check, navigate }: any) => {
    if (check) {
        localStorage.setItem("ef-navigate", path)
        navigate("/splash");
        return;
    }
};
